module.exports = __webpack_public_path__ + "img/52114140_L.d338630f.png";